export const GlobalLoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[hsl(221,89%,10%)] via-black to-[hsl(280,59%,12%)] flex flex-col items-center justify-center relative overflow-hidden">
      {/* Orbs decorativos */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="sobre-orb sobre-orb-1" />
        <div className="sobre-orb sobre-orb-2" />
      </div>

      {/* Trompete SVG + Notas musicais */}
      <div className="relative z-10 flex flex-col items-center">
        <div className="relative loading-trumpet-glow">
          {/* Trompete minimalista line-art */}
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-white/80">
            {/* Bocal */}
            <path d="M10 44 L18 42 L18 48 L10 46 Z" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            {/* Tubo principal */}
            <path d="M18 43 L40 40" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M18 47 L40 50" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            {/* Pistons */}
            <rect x="28" y="33" width="3" height="10" rx="1" stroke="currentColor" strokeWidth="1.2" fill="none"/>
            <rect x="34" y="31" width="3" height="12" rx="1" stroke="currentColor" strokeWidth="1.2" fill="none"/>
            <rect x="40" y="33" width="3" height="10" rx="1" stroke="currentColor" strokeWidth="1.2" fill="none"/>
            {/* Curva inferior */}
            <path d="M40 50 Q48 54 48 46 Q48 38 40 40" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
            {/* Tubo de saída */}
            <path d="M48 42 L56 40" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M48 48 L56 50" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            {/* Campana */}
            <path d="M56 38 Q64 34 70 28 Q72 26 72 30 L72 60 Q72 64 70 62 Q64 56 56 52" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>

          {/* Notas musicais animadas saindo da campana */}
          <svg className="loading-note loading-note-1" width="16" height="20" viewBox="0 0 16 20" fill="none">
            <path d="M4 14 L4 3 Q4 2 5 2 L14 0 L14 11" stroke="white" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
            <circle cx="3" cy="15" r="2.5" fill="white" opacity="0.7"/>
            <circle cx="13" cy="12" r="2.5" fill="white" opacity="0.7"/>
          </svg>
          <svg className="loading-note loading-note-2" width="12" height="16" viewBox="0 0 12 16" fill="none">
            <path d="M3 12 L3 2 Q3 1 4 1 L10 0" stroke="white" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
            <circle cx="2.5" cy="13" r="2" fill="white" opacity="0.7"/>
          </svg>
          <svg className="loading-note loading-note-3" width="10" height="14" viewBox="0 0 10 14" fill="none">
            <path d="M3 10 L3 2 Q3 1 4 1 L8 0" stroke="white" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
            <circle cx="2.5" cy="11" r="2" fill="white" opacity="0.7"/>
          </svg>
          <svg className="loading-note loading-note-4" width="14" height="18" viewBox="0 0 14 18" fill="none">
            <path d="M3 14 L3 3 Q3 2 4 2 L12 0 L12 10" stroke="white" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
            <circle cx="2.5" cy="15" r="2.5" fill="white" opacity="0.7"/>
            <circle cx="11.5" cy="11" r="2.5" fill="white" opacity="0.7"/>
          </svg>
        </div>

        {/* Texto */}
        <p className="mt-8 text-white/50 text-xs tracking-[0.3em] uppercase font-medium loading-text-pulse">
          Carregando
        </p>

        {/* Barra de progresso */}
        <div className="mt-4 w-40 h-[2px] rounded-full bg-white/[0.06] overflow-hidden">
          <div className="loading-progress-bar h-full rounded-full" />
        </div>
      </div>
    </div>
  );
};
